<template>
  <div class="box" id="top_bar2">
    <div class="header">
      <img src="@/assets/img/unnamed.png" alt="" class="logo" />
      <div class="nav_box">
        <div class="nav_list" @click="Go('privacypolicy')">Privacy Policy</div>
        <div class="nav_list" @click="Go('terms')">Terms of Service</div>
      </div>
    </div>
    <div class="h_title">Terms of Service</div>
    <div class="post_inner">
      <div class="content">
        <h4><span style="text-decoration: underline;"><strong>CHOICE MICROFINANCE GENERAL TERMS AND
              CONDITIONS:</strong></span></h4>
        <p>1.<b> Definitions:</b></p>
        <ul>
          <li><b>“Account”:</b> means the bank account held by Partner with Choice Microfinance Bank(CMFB) and which is
            opened and operated in accordance with these terms and conditions.</li>
          <li><b>“Affiliate”:</b> means a Subsidiary or a Holding Company of a person or any other Subsidiary of that
            Holding Company.</li>
          <li><b>“Agreement”:</b>&nbsp;means the application form attached to and read with these terms and any product or
            Service specific terms and conditions which you must comply with.</li>
          <li><b>“ATM</b>”: means an automated teller machine.</li>
          <li><b>“Authorized body”:&nbsp;</b>means any government authority or other entity mandated to exercise
            supervisory or law enforcement authority over the Bank or You.</li>
          <li><b>“Business day”:</b> means any day on which business is usually conducted in the Republic of Kenya,
            excluding Saturdays, Sundays and Public Holidays.</li>
          <li><b>“Constitutional Documents”:</b> As referenced in the application form to which these terms are attached,
            means, in the case of an individual, the identity card or passport, in the case of a company or business
            entity, the memorandum of association, articles of association, certificate of incorporation and registration
            certificate as the case may be, or in the case of a trust, the trust deed and letters of authority, or in the
            case of a partnership, the partnership deed and any related documents as determined by the Bank.</li>
          <li><b>“Credit Reference Bureau”:</b> means all registered credit reference bureaus being utilized by the CMFB
            from time to time.</li>
          <li><b>“Customer Credit Information”:</b> means information concerning:</li>
          <li><span
              style="background-color: transparent; color: var( --e-global-color-text ); font-family: var( --e-global-typography-text-font-family ), Sans-serif; font-weight: var( --e-global-typography-text-font-weight );">(i)
              Your credit history, including applications for credit, credit agreements to&nbsp;</span>which You are or
            have been a party, the pattern of payment or default under any such credit agreements, the incidence of
            enforcement actions with respect to any such credit agreement, the circumstances of termination of any such
            credit agreement;</li>
          <li><span
              style="background-color: transparent; color: var( --e-global-color-text ); font-family: var( --e-global-typography-text-font-family ), Sans-serif; font-weight: var( --e-global-typography-text-font-weight );">(ii)
              Your financial history, including Your past and current income, assets and&nbsp;</span>liabilities and other
            matters with respect to Your income and financial means;</li>
          <li><span
              style="background-color: transparent; color: var( --e-global-color-text ); font-family: var( --e-global-typography-text-font-family ), Sans-serif; font-weight: var( --e-global-typography-text-font-weight );">(iii)
              Your education, employment, career, professional or business history, including&nbsp;</span>the
            circumstances of termination of any employment. Career, professional or business relationship.</li>
          <li><span
              style="background-color: transparent; color: var( --e-global-color-text ); font-family: var( --e-global-typography-text-font-family ), Sans-serif; font-weight: var( --e-global-typography-text-font-weight );">(iv)
              Your identity, including Your name, date of birth, identity number, marital&nbsp;</span>status and family
            relationships, date of registration of business entity, registration number, past and current addresses and
            other contact details and related matters.</li>
          <li><b>“Data”</b> means statistics, facts and/or information as referenced in these terms and conditions.</li>
          <li><b>“Holding Company”:</b> of any person, means a company in respect of which that person is a Subsidiary.
          </li>
          <li><b>“Instrument”:</b> means any item such as a Cheque, Card or related item used for Operating on Your
            Account.</li>
          <li><b>“Law(s)”:</b> means Laws, ordinances, regulations, judgments, and orders of a competent court, central
            bank or Authorized body or related entity.</li>
          <li><b>“Operate”:</b> means the managing of Your Account and Transacting, Operation has a similar meaning.</li>
          <li><b>“PIN”:</b> means a confidential personal identification number used for Operating Your Account, including
            a Customer selected PIN.</li>
          <li><b>“Product(s)”:</b> means the various types of services We offer Our Customers, including services linked
            to an account. Service(s) has a similar meaning.</li>
          <li><b>“Subsidiary”:</b> means an entity of which a person has direct or indirect control or owns directly or
            indirectly more than 50% (fifty per cent) of the voting capital or similar right of ownership and control for
            this purpose means the power to direct the management and the policies of the entity whether through the
            ownership of voting capital, by contract or otherwise. A company shall be treated as a member of a subsidiary
            even if its shares are registered in the name of:</li>
          <li>(i) a nominee; or</li>
          <li>(ii) any party holding security over those shares or</li>
          <li>(iii) that secured party’s nominee.</li>
          <li><b>“Transaction”:</b> means any debit or credit on Your Account made whether or not an Instrument, PIN, or
            device is used. It includes any payment for goods or services, deposit, withdrawal or transfer of money or
            value. Transact or transacting have a similar meaning.</li>
          <li>In this Agreement “You”, “Your” and “the Customer”, refer to any customer Operating an Account or otherwise
            and includes (where appropriate) any person that you have authorized to give instructions on Your Account.
            “We” “Our” and “the Bank” refer to <b>Choice Microfinance Bank</b> a banking company duly incorporated with
            limited liability according to the Laws of Kenya and/or its successors in title and assigns.</li>
          <li>All capitalized terms not otherwise defined herein will have the meaning ascribed to them in the Agreement.
          </li>
        </ul>
        <div><br></div>
        <p>2<b>. Confidentiality:</b></p>
        <ul>
          <li>Confidential Information means, all Data, reports, records, documentation and any information developed or
            acquired in connection with these terms and conditions.</li>
          <li>Confidential information as described above does not apply to:</li>
          <li>(i) Information that is publicly known; or</li>
          <li>(ii) The information which the law or a court compels us to disclose.</li>
          <li>Except as explained above, we will treat each other’s Confidential Information as confidential and we will
            not disclose such Confidential Information to anyone else.</li>
          <li>You agree that the Bank will be entitled to share your confidential information within Choice Microfinance
            Bank, if necessary for the purposes of the services connected with an Account.</li>
          <li>Regardless of anything else in these terms and conditions, the Bank will always be entitled to disclose your
            confidential information to a third party if it is necessary for the proper operation of the services
            connected with an account.</li>
          <li>The mutual obligations in this clause 1 will continue to apply even after these terms and conditions have
            ended and you no longer make use of the services connected with an account.</li>
          <li>You agree that the Confidential Information will not be disclosed to anyone except to the following classes
            of people or in the following exceptional circumstances:</li>
          <li>(i) where the Bank is legally compelled to do so under any Kenyan or any foreign Law as may be applicable
            from time to time (including without limitation, the United States Foreign Account Tax Compliance Act (FATCA)
            or such similar Law in any relevant jurisdiction, any anti-money laundering legislation and any data
            protection legislation);</li>
          <li>(ii) to the Bank’s permitted parties, professional advisers, service providers or independent contractors
            to, or agents of, the permitted parties, such as debt collection agencies, data processing firms and
            correspondents who are under a duty of confidentiality to the Bank or the Bank’s permitted parties;</li>
          <li>(iii) to any actual or potential participant (a party which desires to enter into a contract with us which
            might affect Your rights under Our banking agreement), or assignee (a person to whom any of Our rights or
            obligations under this Agreement are legally transferred), or any officer, employee, agent or adviser of any
            of them;</li>
          <li>(iv)&nbsp; to any credit bureau or credit reference agency, rating agency, business alliance partner,
            insurer or insurance broker, or direct or indirect provider of credit protection, or any permitted parties;
          </li>
          <li>(v) to any financial institution which You have or may have dealings for the purpose of conducting credit
            checks (including in the form of bank references);</li>
          <li>(vi) to any court, tribunal or authority (including an authority investigating an offence) with jurisdiction
            over the permitted parties;</li>
          <li>(vii) to any regulator or tax authority where necessary to establish any tax liabilities in any jurisdiction
            pursuant to orders, agreements with regulators or authorities or otherwise;</li>
          <li>(viii) to the Central Bank of Kenya;</li>
          <li>(ix) to a merchant or a member of a card association where the disclosure is in</li>
          <li>connection with use of a Card; and</li>
          <li>(x) to any authorized person or any security provider;</li>
          <li>=&gt; for fraud prevention purposes;</li>
          <li>=&gt; where it is in the Bank’s interest to disclose;</li>
          <li>=&gt; where the disclosure is made at Your request or with Your written consent;</li>
          <li>=&gt; where it is in the public interest to disclose; and</li>
          <li>=&gt; to anyone we consider necessary in order to provide You with Services in connection with an Account,
            whether they are located in or outside Kenya.</li>
          <li>(xi) You consent to the recipients of the information We disclose, use and transferring the information
            where it is necessary to:</li>
          <li>=&gt; provide You with Services in connection with an Account;</li>
          <li>=&gt; monitor Our compliance with the Law, agreements with any regulator, Authorized body or the permitted
            parties, Choice Microfinance Bank; or</li>
          <li>=&gt; support the Choice Microfinance Bank business, financial and risk monitoring, planning and decision
            making.</li>
        </ul>
        <div><br></div>
        <p>3<b>. Protection of Personal Data:</b></p>
        <ul>
          <li><b>“Personal Data”:</b> means any information relating to an identified or identifiable person (whether
            natural or juristic), such as: name, an identification number, location data, an online identifier or to one
            or more factors specific to the physical, physiological, genetic, mental, economic, cultural or social or
            social identity; and</li>
          <li><b>“Process”:</b> means any operation or activity, automated or not, concerning Personal Data, including:
            collection, recording, organization, structuring; storage, adaptation or alteration; retrieval, consultation
            or use; disclosure by transmission, dissemination, or otherwise making available; or alignment or combination,
            restriction, erasure or destruction of information. “Processing” and “Processed” will have a similar meaning.
          </li>
          <li>You consent to us collecting Your Personal Data from you and where lawful and reasonable, from public
            sources for credit, fraud and compliance purposes, as well as the purposes set out below.</li>
          <li>If You give us Personal Data about or on behalf of another person (including, but not limited to, account
            signatories, shareholders, principal executive officers, trustees and beneficiaries), you confirm that You are
            authorized to:</li>
          <li>=&gt; give us the Personal Data;</li>
          <li>=&gt; consent on their behalf to the Processing of their Personal Data, specifically any cross-border
            transfer of Personal Data into and outside the country where the Products or Services are provided; and</li>
          <li>=&gt; receive any privacy notices on their behalf.</li>
          <li>You consent to us Processing Your Personal Data:</li>
          <li>=&gt; to provide You with Products and Services according to these terms and conditions and any other
            Products and Services that You may apply for;</li>
          <li>=&gt; to carry out statistical and other analyses to identify potential markets and trends, evaluate and
            improve our business (this includes improving existing and developing new Products and Services);</li>
          <li>=&gt; in countries outside the country where the Products or Services are provided. These countries may not
            have the same Laws on protection of Personal Data as the country where the Products or Services are provided.
            Where we can, we will ask the receiving party to agree to our privacy policies;</li>
          <li>=&gt; by sharing Your Personal Data with Our third-party service providers, locally and outside the country
            where the Products or Services are provided. We ask people who provide Services to us to agree to our privacy
            policies if they need access to any Personal Data to carry out their services; and Within Choice Microfinance
            Bank.</li>
          <li>You will find Our Processing practices and privacy statement in the Choice Microfinance Bank’s website or on
            request.</li>
          <li>If you are unsure about your tax or legal position because your Personal Data is processed in countries
            other than where you live, you should obtain independent advice.</li>
          <li>By completing and signing the Agreement, you acknowledge and agree to our collection, use, Processing and
            sharing of Your Personal Data for the above purposes. You also agree that disclosure of information by the
            Bank in the circumstances contemplated by this clause 2 does not violate any duty owed to You in Law or
            pursuant to any agreement between You and the Bank or in the ordinary course of banking business and the
            customs, usage and practice related to banking. Further that the disclosure may be made without further
            reference to, or, authority from you.</li>
        </ul>
        <div><br></div>
        <p><b>4. Credit Reference Bureau Consent:</b></p>
        <ul>
          <li>By submitting an application for BaaS facilities, you agree to be bound by the following requirements
            relating to the submission of information to the Credit Reference Bureau and the issue of whether or not the
            application for credit facilities is approved.</li>
          <li>You hereby irrevocably consent to us collecting, receiving, compiling and retaining any Customer Credit
            Information about You for the purpose of:</li>
          <li>=&gt; assisting us to perform Our statutory assessment of your creditworthiness;</li>
          <li>=&gt; deciding whether or not to grant You credit;</li>
          <li>=&gt; monitoring Your credit profile should we grant you credit; and</li>
          <li>=&gt; filing Our Customer Credit Information with the Credit Reference Bureau.</li>
          <li>You hereby consent to the receipt, sharing, provision and exchange of Data with Credit Reference Bureau and
            with other licensed financial institutions and microfinance deposit taking institutions through the Credit
            Reference Bureau provided that You have the right to lodge a complaint with the Credit Reference Bureau or to
            challenge any Customer Credit Information held by the Credit Reference Bureau in your respect.</li>
          <li>You hereby acknowledge that the Customer Credit Information obtained may include positive or negative
            information regarding Your payment record.</li>
          <li>You hereby acknowledge that the Credit Reference Bureau is required by Law to collect negative information
            on the background and credit history relating to your non-performing obligations.</li>
          <li>You hereby consent to the collection, recording, retention and submission of all Data relating to your
            economic, financial and commercial obligations in order to determine your overall debt exposure and ability to
            pay.</li>
        </ul>
        <div><br></div>
        <p><b>5. Notices:</b></p>
        <ul>
          <li>The postal address You supply on Your application form for an Account will be regarded as Your chosen
            address where notices may be given and documents in legal proceedings may be served. You must notify the Bank
            in writing or by email immediately if your chosen address changes/has changed.</li>
          <li>You choose, for all purposes in connection with the BaaS Products, the address provided in the application
            form. The Bank shall change the address within a reasonable time after it receives written notification from
            you.</li>
          <li>Any notice or communication required to be served on You may be served on You or any of Your officers
            personally by hand delivery, by electronic mail, Short Message Service (SMS), post, notification on Our
            Website www.choice-bank.com or by advertisement in a daily newspaper with national circulation published in
            the Republic of Kenya.</li>
          <li>Delivery by hand shall be effective on actual time of delivery and service by electronic mail shall be to
            Your last known email address and shall be deemed to have been served on the first known Business day
            following transmission. Delivery by post shall be done to the postal address provided in the application form
            or at some other address as notified from time to time by You as provided above and shall be deemed to have
            been effected three (3) business days after posting. Delivery by advertisement in a local daily newspaper
            shall be effective on the first Business day following the date of advertisement.</li>
          <li>Notwithstanding anything to the contrary:</li>
          <li>=&gt; a written notice or other communication actually received by the Customers hall be adequate written
            notice or communication notwithstanding that the notice was not sent to or delivered at the Customer’s chosen
            address; and</li>
          <li>=&gt; any information published by the Bank on the Bank’s website at <b>www.choicebank.com</b> will
            constitute adequate notice for purposes of the Agreement in relation to the matters to which that information
            relates and the effective date of such notice will be the first Business Day following the date of
            publication.</li>
        </ul>
        <div><br></div>
        <p>6<b>. Email and indemnity statements:</b></p>
        <ul>
          <li>You hereby expressly authorize the Bank to:</li>
          <li>=&gt; send statements and/or advice in relation to Your Accounts byway of email to the contact address
            provided by You; and</li>
          <li>=&gt; act on instructions sent from an email address provided by You.</li>
          <li>All documents or information regarding Your Account or Transactions with the Bank will be binding if they
            are in the form of Data messages or accessible in a form which they may be read, stored and retrieved whether
            electronically or as a computer printout for subsequent reference.</li>
          <li>The Bank has no obligation, duty or liability to the Customer on contract, tort or whatsoever for breach of
            statutory duty or otherwise in respect of reliance on any documents or information described in Clause <b>6
              (b)</b> or statements or balances advised via SMS or electronic statements except as provided in this
            Agreement.</li>
          <li>The Customer indemnifies the Bank for any loss or liability occasioned to the Bank (including third party
            claims) due to reliance placed on any documents, information or otherwise premised from an email address
            provided by you.</li>
        </ul>
        <div><br></div>
        <p>7<b>. Tax compliance:</b></p>
        <ul>
          <li>The Bank is subject to the requirements of the Tax Procedures <b>Act No. 29 of 2015 (Tax Act)</b> which is a
            Kenyan Tax Law.</li>
          <li>In compliance with the Tax Act, the Bank may be required to disclose and/or share details of Your Account
            opening information or other Account Data with other entities at Choice Microfinance, and/or other regulatory
            entities outside Choice Microfinance Bank as mandated by the Tax Act, including the Kenya Revenue Authority.
            You hereby consent to the receipt, sharing, provision and exchange of Personal Data within Choice Microfinance
            Bank and/or such regulatory authorities.</li>
          <li>Please note however that the Bank is not a tax advisor and does not provide any professional tax advice
            relating to the Tax Act or any other tax legislation. You are encouraged to procure independent professional
            advice on the Tax Act and all other tax related matters.&nbsp;</li>
        </ul>
        <div><br></div>
        <p>8<b>. Currency:</b></p>
        <ul>
          <li>If any part of a facility is denominated in a foreign currency (“the currency of the Account”), payment
            under or the repayment of such facilities will be made in such foreign currency.</li>
          <li>Any money received by the Bank, or by any person appointed by the Bank, in a currency other than the
            currency of the Account may be converted by the Bank into the currency of the Account or such other currency
            as the Bank considers necessary to cover the obligations or liabilities of the Customer. The Bank shall use
            the Bank’s spot rate of exchange for such conversion.</li>
          <li>In the event of any legislation or extreme change in market conditions affecting the ability of the Bank to
            provide or fund facilities in foreign currency, the Bank reserves the right, at its sole discretion, to
            convert any foreign currency indebtedness by the Customer into Kenya Shillings at the rate ruling on the day
            of such conversion.</li>
          <li>In the event that the Bank demands repayment of any indebtedness of the Customer, after such demand has been
            made, the Bank reserves the right, at its sole discretion, to convert any foreign currency indebtedness by the
            Customer into Kenya Shillings at the Bank’s spot rate ruling at the day of such conversion.</li>
          <li>In exercising the aforementioned rights to convert foreign currency indebtedness into the Kenya Shillings,
            the Bank will not be liable for any losses resulting from exchange rate fluctuations.</li>
        </ul>
        <div><br></div>
        <p>9<b>. Change in control and constitutional documents:</b></p>
        <ul>
          <li>If You are a legal person such as an individual, company, co- operative, trust, partnership, or association
            of persons or any such other entity recognized by Law:</li>
          <li>(i) the Bank shall be entitled in all its actions to rely exclusively upon the documents, including all
            Constitutional Documents and authorizations, submitted by the Customer and in the Bank’s possession;</li>
          <li>(ii) You are required to notify the Bank, in writing, of any proposed or actual changes;</li>
          <li>=&gt; in the direct or indirect ownership, or control (including if there is a change in the person that may
            directly or indirectly exercise the majority of the voting rights in the legal persona), or management of the
            Customer, or any such change in any surety for the Customer’s debt to the Bank; or</li>
          <li>=&gt; to the Customer’s Constitutional Documents; and any collateral given for any facility.</li>
          <li>Any change in control of the Customer will not affect any collateral held by the Bank nor will it release
            any surety/ guarantor from a suretyship/guarantorship.</li>
        </ul>
        <div><br></div>
        <p>1<b>0. Sanctions:</b><br>For the purposes of this clause:</p>
        <ul>
          <li><b>“Counter Terrorism Financing/CTF”:</b> means the combating of Terrorism Financing;</li>
          <li><b>“Funds”:</b> means assets of every kind, whether tangible or intangible, movable or immovable and legal
            documents or instruments evidencing title to, or interest in such assets;</li>
          <li><b>“Sanctioned”:</b> shall mean listed on all or any one of the Sanction Lists and/or subject to any
            Sanctions;</li>
          <li><b>“Sanctioned Entity”:</b> shall mean a person (natural or juristic) who has been sanctioned by a
            Sanctioning Body;</li>
          <li><b>“Sanctions”:</b> shall mean restrictive or related measures imposed from time to time by any one of the
            following regimes and any other regime as may be recognized by the Bank from time to time (each a “Sanctioning
            Body”):</li>
          <li>=&gt; Her Majesty’s Treasury of the United Kingdom (“HMT”);</li>
          <li>=&gt; the Office of Foreign Assets Control of the Department of Treasury of the United States of America
            (“OFAC”);</li>
          <li>=&gt; the United Nations Security Council (“UNSC”);</li>
          <li>=&gt; the European Union’s Common Foreign and Security Policy(“EU”); and</li>
          <li>=&gt; the French Ministry of Economy, Finance and Industry (“MINEFI”).</li>
          <li><b>“Sanctions Lists”:</b> means Sanctions Lists issued by a Sanctioning Body;</li>
          <li><b>“Terrorist act”:</b> means the definition provided pursuant to the Prevention of Terrorism Act Number 30
            of 2012 (Laws of Kenya) as may be amended or replaced from time to time; and</li>
          <li><b>“Terrorism Financing”:</b> means directly or indirectly, unlawfully and willfully providing and/or
            collecting funds with the intention that these Funds will be used in full or part to carry out a Terrorist Act
            by a terrorist organization or be linked to a specific terrorist act.</li>
          <li>You may not operate your account for the purpose of directly or indirectly benefiting a Sanctioned Entity.
          </li>
          <li>You shall indemnify and hold the Bank harmless from all actions, claims and proceedings made against the
            Bank, and all payments, costs and expenses made or incurred by the Bank as a consequence of the seizure of
            Funds and/ or immediate closure of your account(s) due to sanctions imposed on you by a sanctioning body or
            due to direct or indirect dealings between you and a person against whom Sanctions have been imposed by a
            sanctioning body.</li>
          <li>You undertake that you are not currently the subject of any sanctions investigations and have not been
            listed on the sanctions lists. You have no reason to believe you will so become in the foreseeable future.
          </li>
          <li>You acknowledge the Bank’s obligation to adhere to Counter Terrorism Financing/CTF provisions of the Law as
            guided by recognized international principles and you shall ensure that no reputational exposure or no other
            liability is occasioned to the Bank due to Terrorism Financing.</li>
          <li>If We suspect that Your Account has been used fraudulently, negligently, or unlawfully, for money laundering
            activities, or the financing of terrorist and related activities, We may:</li>
          <li>=&gt; restrict activity on; or</li>
          <li>=&gt; without notice to You, immediately:</li>
          <li>=&gt; suspend access to Your Account; or</li>
          <li>=&gt; terminate our relationship.</li>
        </ul>
        <div><br></div>
        <p><b>11. Foreign exchange guidelines:</b></p>
        <ul>
          <li>The Bank is subject to the requirements of the Guidelines on Foreign Exchange, issued by the Central Bank of
            Kenya from time to time.</li>
          <li>In compliance with the Guidelines on Foreign Exchange, the Bank shall be required to gather additional
            information from Customers in respect of all foreign exchange (FX) Transactions above the equivalent of United
            States Dollars (USD) 10, 000. You hereby consent to the provision of supporting documents as shall be required
            by the Bank and/or an Authorized body.</li>
        </ul>
        <div><br></div>
        <p><b>12. Exclusions on our responsibility to you:</b><br>We (including any third party for which We are
          responsible) will not be responsible for<br>any loss (including those listed in clause 11.2 below)resulting
          from:</p>
        <ul>
          <li>the closure of or suspension of access to or restriction of activity on Your Account by us for any reason;
          </li>
          <li>Our compliance with any Laws; or</li>
          <li>any circumstances beyond Our control, such as (without limitation), uncontrollable natural forces in
            operation, strikes or labor disputes, riots, epidemics or pandemics, civil commotion or unrest, wars, acts of
            an enemy, any type of restriction imposed (or action taken) by a Sanctioning Body or any Authorized Body or
            any other third party; any Service interruption, delay, power cuts, failure or malfunction in any equipment,
            electronic data terminal, ATM, network or other systems; lack of available resources from persons other than
            us; electrical equipment or mobile network failure; fires; floods; acts of God; government or regulator
            action; or, without limit ng the foregoing, any other causes not within Our control, and which by the exercise
            of reasonable diligence we are unable to prevent, whether of the class or causes herein before mentioned or
            not.</li>
          <li>The provisions of clause 12 (a) include claims in the contract, for direct, indirect, punitive;
            consequential or special damages, including loss of profit.</li>
        </ul>
        <div><br></div>
        <p><b>13. Anti-bribery and anti–corruption:</b></p>
        <ul>
          <li>You will ensure compliance with all anti-corruption Laws as the same may be enacted or amended from time to
            time and any recognized international principles. (“Anti Corruption Law”)</li>
          <li>In connection with Your Account, You have implemented well established processes and procedures and
            monitoring systems to monitor any unusual activities that may relate to bribery and corruption.</li>
          <li>You shall promptly report any actual, alleged or attempted violation of any applicable Anti Corruption Law
            arising in connection with Your Account and You shall co-operate with us in investigating and responding to
            such actual, alleged or attempted violation.</li>
        </ul>
        <div><br></div>
        <p><b>14. Anti – facilitation of tax evasion:</b></p>
        <ul>
          <li>In connection with Your Account, You shall not engage in activity, practice or conduct which would
            constitute facilitation of tax evasion as recognized by Laws of Kenya and recognized international principles.
          </li>
          <li>You have implemented well established processes and procedures and monitoring systems to monitor any unusual
            activities that may relate to tax evasion.</li>
          <li>Should We have reasonable grounds to suspect that you have assisted or attempted the facilitation of the
            evasion of tax, We may:</li>
          <li>=&gt; request additional information prior to processing transactions;</li>
          <li>=&gt; not process a Transaction where it is suspected it is in relation to an incidence of tax evasion, or
            relates to the facilitation of tax evasion and the originator of the transaction cannot provide information to
            the contrary; and</li>
          <li>=&gt; report the violation, or suspected violation to an authorized body and subsequently act according to
            the guidance of such authorized body or related body.</li>
          <li>=&gt; You explicitly indemnify us against any actions, proceedings, claims and/or demands that may be
            brought against us or Our Affiliates, as well as against losses, damages, costs and expenses which We may
            incur or sustain in connection with the seizure, blocking or withholding of any funds by an Authorized or
            related body.</li>
        </ul>
        <div><br></div>
        <p><b>15. Non-waiver:</b></p>
        <ul>
          <li>The failure by the Bank to exercise any of its rights on the due date or any indulgence granted to the
            Customer shall not be construed as a waiver, abandonment or novation of any of the rights of the Bank in these
            terms and conditions.</li>
        </ul>
        <div><br></div>
        <p><b>16. Changes:</b></p>
        <ul>
          <li>The Bank may immediately amend the pricing structure pursuant to these terms and conditions if there is any
            change in Law, statute, regulation, ruling, directive, policy or any similar event or change with which the
            Bank is obliged to comply resulting in an increase in cost to the Bank in providing the Services or any part
            thereof. If the Bank does so, it will advise the Customer.</li>
        </ul>
        <div><br></div>
        <p><b>17. Governing law:</b></p>
        <ul>
          <li>These terms and conditions shall be governed by and in accordance with the laws of Kenya.</li>
          <li>You consent to courts of competent jurisdiction and to the Bank, at its option, taking legal proceedings to
            enforce or implement any of the Bank’s rights.</li>
        </ul>
        <div>&nbsp;</div>
        <p><b>18. General:</b></p>
        <ul>
          <li>We may change these terms from time to time by notice to You. A change will not terminate this Agreement.
          </li>
          <li>You may not change any provisions of these terms.</li>
          <li>The relevant Product or Service specific terms and conditions will apply if there is any conflict between
            them and the terms in this document.</li>
          <li>Any favor or concession we may allow you will not affect or substitute any of our rights against you.</li>
          <li>The invalidity, illegality or unenforceability of any of the clauses of these terms or any Product or
            Service specific terms and conditions shall not affect the validity, legality and enforceability of the
            remaining clauses of these terms or any Product or Service specific terms and conditions.</li>
        </ul>
        <div><br></div>
        <p><b>19. Customer complaints:</b><br>If you have any questions or complaints about Your Account, You may contact
          Our Customer Care Centre by calling <b>0731 225 879/ 020 388 2206/7</b> or by email at
          <b>info@choice-bank.com</b> or via the Website <b>www.choice-bank.com</b>
        </p>

      </div>
    </div>
    <footer>
      <!-- <div class="fl" @click="Go('privacypolicy')">&copy;2021 Choice</div> -->
      <div class="fr" @click="GoTop">
        To the top <span class="arrow">↑</span>
      </div>
    </footer>
    <!-- <img src="@/assets/img/current.png" alt="" class="bg_img" /> -->
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    Go(route) {
      this.$router.push("/" + route);
    },
    GoTop() {
      let anchorElement = document.getElementById("top_bar2");
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    },
  },
};
</script>
<style>
html,
body {
  padding: 0;
  margin: 0;
  background: #ffffff;
  width: 100%;
  height: 100%;
  font-size: 0;
}

div {
  margin: 0;
  padding: 0;
}

img {
  display: inline-block;
  margin: 0;
  padding: 0;
  border: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

div {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

.header {
  max-width: 1200px;
  width: 100%;
  height: 90px;
  padding: 28px 0;
  overflow: hidden;
  margin: 0 auto;
}

@media screen and (min-width: 1200px) {
  .logo {
    width: 90px;
    height: 90px;
    cursor: pointer;
    float: left;
  }

  .nav_box {
    float: right;
    height: 90px;
    line-height: 90px;
  }

  .nav_list {
    height: 90px;
    line-height: 90px;
    display: inline-block;
    margin-left: 25px;
    cursor: pointer;
    color: #cd2653;
    font-size: 18px;
  }

  .h_title {
    font-size: 84px;
    height: 95px;
    text-align: center;
    width: 100%;
    font-weight: 700;
    padding: 80px 0;
  }
}

@media screen and (max-width: 800px) {
  .header {
    width: 100%;
    height: 40px;
    padding: 10px 0;
    overflow: hidden;
    margin: 0 auto;
  }

  .logo {
    width: 40px;
    height: 40px;
    cursor: pointer;
    float: left;
    margin-left: 2%;
  }

  .nav_box {
    float: right;
    height: 40px;
    line-height: 40px;
    width: 70%;
  }

  .nav_list {
    height: 40px;
    line-height: 40px;
    display: inline-block;
    cursor: pointer;
    color: #cd2653;
    font-size: 16px;
    margin-right: 2%;
  }

  .h_title {
    font-size: 36px;
    text-align: center;
    width: 100%;
    font-weight: 700;
    padding: 20px 0;
  }
}

.post_inner {
  padding: 80px 0;
  width: 100%;
  background-color: rgb(245, 239, 224);
}

.content {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  font-size: 21px;
  color: #000000;
  font-family: NonBreakingSpaceOverride, "Hoefler Text", Garamond,
    "Times New Roman", serif;
  line-height: 1.5;
  padding: 0 2%;
  box-sizing: border-box;
}

.content a {
  color: #cd2653;
}

footer {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 43px;
  overflow: hidden;
  height: 30px;
  font-size: 18px;
  box-sizing: border-box;
}

.fl {
  float: left;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  font-weight: 700;
}

.fr {
  float: right;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  color: #6d6d6d;
}

.bg_img {
  position: absolute;
  opacity: 0;
}

.elementor-widget-text-editor.elementor-drop-cap-view-stacked .elementor-drop-cap {
  background-color: #69727d;
  color: #fff
}

.elementor-widget-text-editor.elementor-drop-cap-view-framed .elementor-drop-cap {
  color: #69727d;
  border: 3px solid;
  background-color: transparent
}

.elementor-widget-text-editor:not(.elementor-drop-cap-view-default) .elementor-drop-cap {
  margin-top: 8px
}

.elementor-widget-text-editor:not(.elementor-drop-cap-view-default) .elementor-drop-cap-letter {
  width: 1em;
  height: 1em
}

.elementor-widget-text-editor .elementor-drop-cap {
  float: left;
  text-align: center;
  line-height: 1;
  font-size: 50px
}

.elementor-widget-text-editor .elementor-drop-cap-letter {
  display: inline-block
}</style>
